import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './bdetails.module.css';

const BookingDetails = () => {
    const { id: booking_id } = useParams();
    const navigate = useNavigate()
    const url = process.env.REACT_APP_URL;
    const [data, setData] = useState();
    const [order, setOrder] = useState();

    const fetchBookingDetails = async () => {

        try {
            const response = await axios.get(`${url}/api/outstation/fetchOutstationTripById/${booking_id}`);
            console.log('Booking details:', response.data);
            setData(response.data.data);
            setOrder(response.data.order);
            console.log("here in the response", response?.data?.data?.["Status info"]?.status);
        } catch (error) {
            console.error('Error fetching booking details:', error);
        }
    }
    useEffect(() => {
        fetchBookingDetails();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.heading}>
                <button className={styles.btn}
                    onClick={() =>
                        navigate(-1)
                    }>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <h2 className={styles.head}>
                    Outstation B Details
                </h2>
                <div className={styles.status}  >

                    {data?.Status?.Status}
                </div>
            </div>
            <div className={styles.details}>
                {/* <div className={styles.con1}> */}

                {/* {Object.entries(data || {}).map(([section, values]) => (
                    <div key={section} className={styles.section}>
                        <h3>{section.replace('_', ' ').toUpperCase()}</h3>
                        <div className={styles.contain}>
                            {Object.entries(values).map(([key, value]) => (
                                <div key={key} className={styles.line}>
                                    <strong>{key}:</strong> {String(value ?? '-')}

                                </div>

                            ))}
                        </div>
                    </div>
                ))} */}
                {order?.map((section) => (
                    section !== "Status" && data[section] && (
                        <div key={section} className={styles.section}>
                            <h3>{section}</h3>
                            <div className={styles.contain}>
                                {Object.entries(data[section]).map(([key, value]) => (
                                    <div key={key} className={styles.line}>
                                        <strong>{key}:</strong> {String(value ?? '-')}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};


export default BookingDetails;
// booking_info: Object { booking_id: "a77b4c68-f03f-4dad-abe5-64a968d698ac", created_at: "2025-10-07 21:20:14.000000", expire_in_min: 10, … }

// fare_info: Object { estimated_fare: 5847, service_charge: 379 }

// rider_info: Object { rider_id: "60db4e5f-f431-4ce2-bdee-7bf8369cfc4a", rider_name: "Pangkam Damang", rider_contact: "7005643266" }

// status_info: Object { status: "Expired", status_code: "EXPIRED" }

// trip_info: Object { trip_mode: "ONE_WAY", trip_type: "One way trip", distance_km: 78.89, … }

// vehicle_info: Object { driver_ID: null, vehicle_name: "Luxury", seat_capacity: 7, … }